export default {"src":"/_next/static/media/temazcal.f77dea12.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};